import React, { useState } from "react";
import { Modal, Row, Col, Typography, Button } from "antd";
import { ExclamationCircleTwoTone } from "@ant-design/icons";

const { Title, Paragraph } = Typography;

const Success = (props) => {
  return <>{/* <div>Success</div> */}</>;
};

export default Success;
